<template>
  <v-container class="justify-center" fluid>
    <v-card :elevation="1" v-if="data">
      <v-progress-linear v-if="loading" :indeterminate="loading"></v-progress-linear>
      <v-list-item two-line link @click="editName = true">
        <v-list-item-content>
          <v-list-item-title>{{ $t("servicesystem.common_objects.user.name") }}</v-list-item-title>
          <v-list-item-subtitle v-if="!editName">{{ data.Name }}</v-list-item-subtitle>
          <v-list-item-subtitle v-else><v-text-field v-model="data.Name" hide-details outlined dense autofocus
              @blur="saveData"></v-text-field></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>{{ $t("servicesystem.loginform.text.login_email") }}</v-list-item-title>
          <v-list-item-subtitle>{{ data.Email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item two-line link @click="editLanguage = true">
        <v-list-item-content>
          <v-list-item-title>{{ $t("language") }}</v-list-item-title>
          <v-list-item-subtitle v-if="!editLanguage">{{ data.Language.Text }}</v-list-item-subtitle>

          <v-list-item-subtitle v-if="editLanguage">
            <v-select :items="data.AvailableLanguages" item-text="Text" return-object autofocus dense outlined
              hide-details v-model="data.Language" @blur="saveData"
              @change="saveData"></v-select></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "MyAccount",
  components: {
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: true,
      data: null,
      editName: false,
      editLanguage: false
    };
  },

  mounted() {
    clientAPI.methods.getMyAccount().then(response => {
      this.data = response;
    }).finally(() => {
      this.loading = false;
    })
  },

  methods: {
    saveData() {
      this.editLanguage = false;
      this.editName = false;
      this.loading = true;
      clientAPI.methods.updateMyAccount(this.data).then(response => {
        this.data = response
        //console.log(response);
        this.$i18n.locale = response.Language.Culture;
        this.$store.dispatch("getUserInfo");
      }).finally(() => {
        this.loading = false;
      })
    }
  },

  computed: {
  },

  watch: {
  },
};
</script>